import {createReducer} from '@reduxjs/toolkit';
import {deselectFeatureRef, selectFeatureRef} from '@actions/selected-features';

const initialState = null;

const selectedFeatureRef = createReducer(initialState, builder => {
  builder.addCase(selectFeatureRef, (state, {payload}) => payload);
  builder.addCase(deselectFeatureRef, () => null);
});

export default selectedFeatureRef;
